<template>
  <card class="flex flex-col mb-4">
    <div class="flex items-center">
      <ui-image
        class="me-2"
        width="10"
        height="10"
        contain
        :src="image"
        :image-dimensions="[128, 48]"
      />
      <ui-title type="h3" class="m-4">
        {{ title }}
      </ui-title>
    </div>

    <div class="m-4 flex flex-col flex-1">
      <p>
        {{ info }}
      </p>

      <divider v-if="subInfo" class="my-4" />
      <p v-if="subInfo">
        {{ subInfo }}
      </p>
    </div>
  </card>
</template>
<script>
import VueTypes from 'vue-types'
import { Card, UiTitle, UiImage, Divider } from '~/components/atoms'
export default {
  components: {
    Card,
    UiTitle,
    UiImage,
    Divider,
  },
  props: {
    title: VueTypes.string.def(''),
    image: VueTypes.object.def(''),
    info: VueTypes.string.def(''),
    subInfo: VueTypes.string.def(''),
  },
}
</script>
